import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { AuthService } from '@services/auth.service'
import { PlatformService } from '@services/platform.service'
import { AccountService } from '@services/account.service'
import { ToastService } from '@common/services'
import { UserRole } from '@models/user.model'
import { NATIVE_APP_ALLOWED_PREFIXES, NATIVE_APP_HOME, NATIVE_APP_SIGNER_ONLY_MESSAGE } from '@constants/native-app'

export const authGuard: CanActivateFn = (_, state) => {
	const router = inject(Router)
	const auth = inject(AuthService)
	const verify = auth.token != null && !auth.expired

	if (!verify) {
		auth.resetSession(false)
		return router.createUrlTree(['/auth/signin'], { queryParams: { redirect: state.url } })
	}

	if (inject(PlatformService).mobile) {
		return nativeAppAccess(state.url, router, auth)
	}

	return verify
}

/**
 * No app nativo só o signatário entra (spec 058). A checagem do login cobre apenas o envio do formulário: a sessão
 * restaurada ao abrir o app e a sessão externa chegam aqui sem passar por ela.
 */
function nativeAppAccess(url: string, router: Router, auth: AuthService) {
	const roles: string[] = inject(AccountService).user?.roles ?? []

	if (!roles.includes(UserRole.SIGNER)) {
		void auth.resetSession(false)
		inject(ToastService).warn(NATIVE_APP_SIGNER_ONLY_MESSAGE)
		return router.createUrlTree(['/auth/signin'])
	}

	if (!NATIVE_APP_ALLOWED_PREFIXES.some(prefix => url.startsWith(prefix))) {
		return router.createUrlTree([NATIVE_APP_HOME])
	}

	return true
}
